import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Loading } from '@icp/components';
import FormRenderer from '@icp/form-renderer';
import { transformToEChartElement } from './utils';
import { makeTitleElement } from '../utils';

export default function IcpChart({ children: data }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [schema, setSchema] = useState();

  useEffect(() => {
    setLoading(true);
    transformToEChartElement(data)
      .then((res) => {
        const [eChartElementConfig, title] = res || [];
        if (!eChartElementConfig) return;
        setSchema({ fields: [makeTitleElement(title), eChartElementConfig] });
      })
      .catch(setError)
      .finally(() => setLoading(false));
  }, [data]);

  if (loading) return <Loading />;
  if (error) return <div>{error.message || 'Unknown error'}</div>;
  if (!schema) return null;

  return <FormRenderer schema={schema} />;
}

IcpChart.propTypes = {
  children: PropTypes.string,
};
